import React from 'react';

const Error = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "33",
    height: "33",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.5611 30.1369C9.06322 30.1369 2.98535 24.059 2.98535 16.5611C2.98535 9.06322 9.06322 2.98535 16.5611 2.98535C24.059 2.98535 30.1369 9.06322 30.1369 16.5611C30.1369 24.059 24.059 30.1369 16.5611 30.1369ZM15.2035 15.2035V23.349H17.9187V15.2035H15.2035ZM15.2035 9.77323V12.4884H17.9187V9.77323H15.2035Z",
      fill: "#DC2C2C"
    }
  )
);

export { Error };
//# sourceMappingURL=Error.js.map
